import React, { useEffect, useState, useMemo } from "react";
import "./CustomGrid.css";

export default function RowSelect({
  value = "",
  options = [],
  rowId,
  onChange = () => {},
  statusColors = {},
}) {
  const [selectedValue, setSelectedValue] = useState(value || "");

  useEffect(() => {
    setSelectedValue(value || "");
  }, [value]);

  // normaliza chaves (ex: "Confirmado" → "confirmado")
  const normalizedStatusColors = useMemo(() => {
    const map = {};
    for (const [key, val] of Object.entries(statusColors)) {
      map[key.toLowerCase().trim()] = val;
    }
    return map;
  }, [statusColors]);

  const normalized = (selectedValue || "").toLowerCase().trim();
  const { background = "transparent", color = "#000" } =
    normalizedStatusColors[normalized] || {};

  const handleChange = (e) => {
    const newValue = e.target.value;
    setSelectedValue(newValue);
    onChange(rowId, newValue);
  };

  return (
    <div
      style={{
        backgroundColor: background,
        borderRadius: 4,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100px",
        height: "24px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <select
        value={selectedValue}
        onChange={handleChange}
        style={{
          width: "60px",
          height: "100%",
          background: "transparent",
          color,
          border: "none",
          outline: "none",
          fontSize: "12px",
          fontWeight: 600,
          textAlign: "center",
          appearance: "none",
          WebkitAppearance: "none",
          MozAppearance: "none",
        }}
      >
        {options.map((opt) => {
          const key = opt.value.toLowerCase().trim();
          const optStyle = normalizedStatusColors[key] || {};
          return (
            <option
              key={opt.value}
              value={opt.value}
              style={{
                backgroundColor: optStyle.background || "#fff",
                color: optStyle.color || "#000",
              }}
            >
              {opt.label}
            </option>
          );
        })}
      </select>
    </div>
  );
}
